import { useFlags } from 'launchdarkly-react-client-sdk';

export const PREPAID_WALLET_ENABLED_FLAG = 'fintech.retail-payments.prepaid.consumer-enablement.rollout';

export function useIsPrepaidWalletEnabled(): boolean {
  const flags = useFlags();
  return flags[PREPAID_WALLET_ENABLED_FLAG] ?? false;
}
